import { useState } from "react";
import $api from "./openapi";

export default function useUploadFiles({
  onSuccess,
}: {
  onSuccess?: (fileIds: string[]) => void;
}) {
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [files, setFiles] = useState<File[]>([]);

  const { mutate: upload, isPending: isUploading } = $api.useMutation(
    "post",
    "/api/files",
  );

  const uploadFiles = (files: File[]) => {
    return upload(
      {
        body: {
          files: files as unknown[] as string[],
        },
        bodySerializer: (body) => {
          // file upload is unfortunately not properly supported by openapi-typescript: https://github.com/openapi-ts/openapi-typescript/issues/1214
          // luckily, this is a workaround. ref: https://github.com/openapi-ts/openapi-typescript/issues/1214#issuecomment-1957965890
          const formData = new FormData();
          for (const file of body.files) {
            formData.append("files", file);
          }
          return formData;
        },
      },
      {
        onSuccess: (fileIds) => {
          setFileIds(fileIds);
          if (onSuccess) {
            onSuccess(fileIds);
          }
        },
      },
    );
  };

  return {
    isUploading,
    uploadFiles,
    fileIds,
    files,
    setFiles,
  };
}
